const personalController = "personal";
const documentController = "/document";
const usersController = "users";
const authController = "auth";
const dashboardController = "dashboard";
const Lookup = "lookup";
const notificationsController = "notification"; 

export const API_CONFIG_URLS = {
  AUTH: {
    ME: `${personalController}/profile`,
    LOGIN: `${authController}/login`,
    LOGOUT: `${usersController}/logout`,
    RESEND_OTP: `${usersController}/forgot-password`,
    FORGOT_PASSWORD: `${usersController}/forgot-password`,
    RESET_PASSWORD: `${usersController}/reset-password`,
    VERIFY_FORGOT_OTP: `${usersController}/verify-password-otp`,
    CHANGE_PASSWORD: `${personalController}/change-password`,
  },
  DASHBOARD: {
    GET_DASHBOARD_STATS_CARDS: `${dashboardController}/cards`,
    GET_DASHBOARD_STORY_METHODS: `${dashboardController}/story/methods/stats`,
    GET_DASHBOARD_SUBSCRIPTION_REVENUE_GRAPH: `${dashboardController}/subscription/revenue`,
    GET_DASHBOARD_LISTENING_ACTIVITY_GRAPH: `${dashboardController}/listening-activity/graph`,
    GET_DASHBOARD_VOICE_CLONES_STATS: `${dashboardController}/voiceclones/stats`,
    
  },
  USERS: {
    GET_USERS_LIST: `${usersController}/users/list/admin`,
    GET_USERS_STATS: `${usersController}/user-stats`,
    DELETE_USER: `${usersController}/delete-user`,
    GET_USER_DETAILS: `${usersController}/users/details`,
    UPDATE_USER_STATUS: `${usersController}/update-account-status`,
  },
 
  PROFILE: {
    CHANGE_PASSWORD: `${personalController}/change-password`,
    EDIT_PROFILE: `${personalController}/profile`,
  },
  DOCUMENTS: {
    UPLOAD_DOCUMENTS: `${documentController}`,
    DOWNLOAD_IMAGE: `${documentController}/fetch`,
  },
  LOOKUP: {
    GET_CITIES: `/${Lookup}/admin/location`,
    GET_CATEGORIES: `/${Lookup}/categories`,
    GET_ALL_USERS: `/${Lookup}/admin/users`,
  },
  NOTIFICATIONS: {
    GET_NOTIFICATION_LISTINGS: `/${notificationsController}`,
    MARK_ALL_AS_READ: `/${notificationsController}/mark`,
    NOTIFICATION_COUNT: `/${notificationsController}/count`
  },
};

export const multiFormDataHeader = {
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "text/plain",
  },
};

export const jsonFormatDataHeader = "application/json";
